var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-radio',_vm._g(_vm._b({staticClass:"tes-radio",attrs:{"color":"white"}},'q-radio',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }